import { defineComponent as _defineComponent } from 'vue'
import { AppButton } from '@shared/ui'
import { useRestaurantModel } from '@entities/restaurant'


export default /*#__PURE__*/_defineComponent({
  __name: 'RestaurantNotWorkingModal',
  emits: ['callYandexMetricGoal', 'toggleMenuFooter'],
  setup(__props, { emit }) {



const restaurantModel = useRestaurantModel()

const closeModal = () => {
  emit('callYandexMetricGoal', 'cashboxNotWorkClickOk')
  emit('toggleMenuFooter', 'order')
  restaurantModel.showModal = false
}

return { __sfc: true,emit, restaurantModel, closeModal, AppButton }
}

})